import React from "react";
import { RequiredStyle } from "./required.style";

const Required = () => <RequiredStyle>*</RequiredStyle>;

export default Required;
